// extracted by mini-css-extract-plugin
export var btnToggle = "event-summit-agenda-module--btn-toggle--f8e7b";
export var btnToggleActive = "event-summit-agenda-module--btn-toggle-active--0231c";
export var cardBg = "event-summit-agenda-module--card-bg--a9747";
export var listSummitAgenda = "event-summit-agenda-module--list-summit-agenda--86370";
export var summitTagCustomersOnly = "event-summit-agenda-module--summit-tag-customers-only--720c7";
export var summitTagHighlight = "event-summit-agenda-module--summit-tag-highlight--468be";
export var summitTags = "event-summit-agenda-module--summit-tags--ab5fa";